module.exports = __webpack_public_path__ + "img/cp-camera.75e73b65.svg";